import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  MatChipGrid,
  MatChipInput,
  MatChipRemove,
  MatChipRow,
} from '@angular/material/chips';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-filter',
  imports: [
    FormsModule,
    MatCheckbox,
    MatChipRow,
    MatFormField,
    MatInput,
    MatLabel,
    TranslatePipe,
    MatIcon,
    MatChipRemove,
    MatChipGrid,
    MatChipInput,
  ],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  standalone: true,
})
export class FilterComponent {
  @Input() filterType: string[];
  @Input() filterMode: boolean;
  @Input() titel: string;

  @Output() deleteRequests = new EventEmitter<number>();
  @Output() editRequests = new EventEmitter<string>();

  educationInput: string = '';

  delete(idx: number) {
    this.deleteRequests.emit(idx);
  }

  add() {
    this.editRequests.emit(this.educationInput);
    this.educationInput = '';
  }
}
